import { Component } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { NAService } from "../API/na.service";
import { IAPIRx } from "../API/api.base";
import { DialogPage } from "../lib/common/common.data";
import { AppService } from "../app.service";

@Component({
    template: `
<div class="unsub-page" [style.background-image]="'url(' + appSvc.bgUrl + ')'">
    <div class="row">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
            <div class="unsub-box">
                <div class="logo">
                    <img [src]="appSvc.logoDarkUrl | safe: 'url'">
                </div>
                <div class="content">
                    <button type="button" class="btn-unsub"
                                        [disabled]="_page === _enumPage.submit" (click)="unsubscribe()">
                                        <span class="btn-unsub-text">
                                            <i *ngIf="_page === _enumPage.submit" class="fas fa-sync-alt fa-spin btn-unsub-icon"></i>
                                            Unsubscribe
                                        </span>
                    </button>
                    <p *ngIf="_page === _enumPage.result && !_errorMessage" class="unsub-message success">
                        You have successfully unsubscribed from our emails.
                    </p>
                    <p *ngIf="_page === _enumPage.result && _errorMessage" class="unsub-message error">
                        {{ _errorMessage }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
    `,
    styles: [`
        .unsub-page {
            position: relative;
            min-height: 100vh;
            width: 100%;
            box-shadow: inset 0 0 0 2000px rgba(14, 14, 14, 0.3);
            background-position: center center;
            background-repeat: no-repeat;
            background-attachment: fixed;
            background-size: cover;
            background-color: var(--gray-5);
        }

        .unsub-box {
            background-color: rgba(242, 244, 246, 0.9);
            text-align: center;
            margin-top: 60px;
        }

        .unsub-box .logo {
            padding-top: 1rem;
        }

        .unsub-box .logo > img {
            width: 70%;
            max-height: 128px;
            object-fit: contain;
        }

        .unsub-box .content {
            margin: 2rem 2.5rem;
            padding-bottom: 2.5rem;
            font-size: 1.2rem;
        }

        .btn-unsub {
            display: flex;
            justify-content: center;
            align-items: center;
            color: var(--white);
            background-color: var(--blue-2);
            font-size: 16px;
            font-weight: bold;
            border-radius: 1.5rem;
            border: none;
            letter-spacing: 1px;
            padding: 0.8rem 2rem;
            text-transform: uppercase;
            cursor: pointer;
            width: 100%;
        }

        .btn-unsub-text {
            position: relative;
            display: inline-block;
            line-height: 1.5;
        }

        .btn-unsub-icon {
            position: absolute;
            right: 100%;
            margin-right: 1rem;
            line-height: 1.5;
        }

        .btn-unsub:not(:disabled):hover {
            background-color: var(--blue-3);
        }

        .btn-unsub:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }

        .unsub-message {
            margin: 1.5rem 0 0;
        }

        .unsub-message.success {
            color: var(--green-2);
        }

        .unsub-message.error {
            color: var(--red-1);
        }
    `],
    standalone: false
})
export class EmailUnsubscribeComponent {
    _page: DialogPage = DialogPage.action;
    _enumPage: typeof DialogPage = DialogPage;

    _token: string;
    _email: string;
    _scope: string;

    _errorMessage: string;

    constructor(private route: ActivatedRoute, private naSvc: NAService, public appSvc: AppService) {
        this.route.queryParamMap
            .subscribe((params: ParamMap) => {
                this._token = params.get('token');
                this._email = params.get('email');
                this._scope = params.get('scope');
            });
    }

    unsubscribe(): void {
        this._page = DialogPage.submit;
        this._errorMessage = null;

        if (!this._token || !this._email) {
            this._errorMessage = 'Invalid unsubscribe request.';
            this._page = DialogPage.result;
            return;
        }

        this.naSvc.unsubscribeAlert({ token: this._token, email: this._email, scope: this._scope }).subscribe((res: IAPIRx<void>) => {
            console.log('---------- unsubscribe response ----------', res);
            if (res.error !== 0) {
                this._errorMessage = res.errorMessage || 'Unsubscribe failed. Please try again later.';
            }

            this._page = DialogPage.result;
        });
    }
}
